import { render, staticRenderFns } from "./MyContracts.vue?vue&type=template&id=8fb85d7e&scoped=true&"
import script from "./MyContracts.vue?vue&type=script&lang=js&"
export * from "./MyContracts.vue?vue&type=script&lang=js&"
import style0 from "./MyContracts.vue?vue&type=style&index=0&id=8fb85d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb85d7e",
  null
  
)

export default component.exports